export default "__VITE_ASSET__DuxtZzyL__"